import axios from 'axios'

const api = axios.create({
  baseURL: '/api',
})

// Interceptor per aggiungere token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('erp_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Interceptor per gestire errori auth
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Non redirigere se siamo su una pagina pubblica (schede compilazione esterna)
      if (window.location.pathname.startsWith('/public/')) {
        return Promise.reject(error)
      }
      localStorage.removeItem('erp_token')
      localStorage.removeItem('erp_user')
      window.location.href = '/'
    }
    return Promise.reject(error)
  }
)

export default api
